import { apiService } from './apiService';

export const expenseCategoryService = {
  async getCategories(includeInactive = false) {
    return apiService.get(`/expense-categories${includeInactive ? '?includeInactive=true' : ''}`);
  },

  async createCategory(data: { code: string; label: string; keywords?: string; sortOrder?: number; isActive?: boolean }) {
    return apiService.post('/expense-categories', data);
  },

  async updateCategory(id: string | number, data: { code: string; label: string; keywords?: string; sortOrder?: number; isActive?: boolean }) {
    return apiService.put(`/expense-categories/${id}`, data);
  },

  async deleteCategory(id: string | number) {
    return apiService.delete(`/expense-categories/${id}`);
  },
};
